import { useFormContext, useFormField } from '@cian/frontend-request-form-widget';
import { Input } from '@cian/ui-kit';
import * as React from 'react';
import { FormField } from '../../../components/FormField';
import { useFieldError } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var InputField = function InputField(props) {
  var placeholder = props.placeholder,
    label = props.label,
    autoFocus = props.autoFocus,
    name = props.name,
    required = props.required,
    autoComplete = props.autoComplete,
    description = props.description;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting;
  var _useFieldError = useFieldError(name),
    hideError = _useFieldError.hideError,
    errorMessage = _useFieldError.errorMessage;
  var _useFormField = useFormField({
      name: name
    }),
    _useFormField$field = _useFormField.field,
    _useFormField$field$v = _useFormField$field.value,
    value = _useFormField$field$v === void 0 ? '' : _useFormField$field$v,
    onBlur = _useFormField$field.onBlur,
    onChange = _useFormField$field.onChange;
  var handlerChange = React.useCallback(function (event) {
    onChange(event);
    hideError();
  }, [onChange, hideError]);
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    description: description,
    required: required,
    errorMessage: errorMessage,
    children: function children(_ref) {
      var id = _ref.id;
      return /*#__PURE__*/_jsx(Input, {
        id: id,
        name: name,
        value: value,
        placeholder: placeholder,
        autoFocus: autoFocus,
        disabled: isSubmitting,
        invalid: !!errorMessage,
        autoComplete: autoComplete,
        maxLength: 100,
        onChange: handlerChange,
        onBlur: onBlur
      });
    }
  });
};
InputField.displayName = 'InputField';